import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@mdi/font/scss/materialdesignicons.scss'
import Vue from 'vue'
import { baseVueRouter } from './plugins/vue-router'
import { baseVueI18n } from './plugins/vue-i18n'
import { baseVuexStore } from './plugins/vuex-store'
import { baseVuetify } from './plugins/vuetify'
import { baseFirebase } from './plugins/firebase'
import { baseServiceWorker } from './plugins/service-worker'
import { baseAxios } from './plugins/axios'
import { clearLocalStorage } from './utils/storage-util'
import { appStore } from './modules/app/store'
import { authStore } from './modules/auth/store'
import BaseIndexVue from './Index.vue'

const MAIN_DEFAULT_MODULE_NAMES = [
  'app',
  'auth'
]
const MAIN_DEAFULT_STORAGE_KEYS = [
  'app.routePath',
  'app.language',
  'app.themeDark',
  'app.notifications',
  'app.serverVersion',
  'auth.token',
  'auth.notificationClient',
  'serviceWorker.updated'
]

async function main(): Promise<void> {
  baseVueRouter.setDefaultModuleNames(MAIN_DEFAULT_MODULE_NAMES)
  baseVueI18n.setDefaultModuleNames(MAIN_DEFAULT_MODULE_NAMES)
  baseVuexStore.setDefaultModuleNames(MAIN_DEFAULT_MODULE_NAMES)
  baseVuetify.setDefaultModuleNames(MAIN_DEFAULT_MODULE_NAMES)

  baseVueRouter.registerRoutePathHook((routePath) => appStore.setRoutePath(routePath))
  baseVueRouter.registerAccessIdHook((accessId) => authStore.setAccessId(accessId))
  baseVueI18n.registerLanguageHook((language) => appStore.setLanguage(language))
  baseVuetify.registerThemeDarkHook((themeDark) => appStore.setThemeDark(themeDark))
  baseVuetify.registerNotificationHook(async (notification) => appStore.addNotification(notification))
  baseFirebase.registerNotificationHook(async (notification) => appStore.addNotification(notification))
  baseFirebase.registerNotificationClientHook(async (notificationClient) => authStore.updateNotificationClient(notificationClient))
  baseServiceWorker.registerNotificationHook(async (notification) => appStore.addNotification(notification))
  baseAxios.registerUnauthorizedErrorHook(async (unauthorizedError) => baseVueRouter.pushRouteUnauthorized(unauthorizedError))
  await appStore.registerRoutePathHook(async (routePath) => baseVueRouter.setRoutePath(routePath))
  await appStore.registerLanguageHook((language) => {
    baseVueI18n.setLanguage(language)
    baseVuetify.setLanguage(language)
    baseAxios.setLanguage(language)
  })
  await appStore.registerThemeDarkHook((themeDark) => baseVuetify.setThemeDark(themeDark))
  await appStore.registerNotificationsHook((notifications) => baseVuetify.setNotifications(notifications))
  await authStore.registerTokenHook((token) => baseAxios.setToken(token))
  await authStore.registerUserModulesHook((userModules) => {
    baseVueRouter.setUserModules(userModules)
    baseVueI18n.setUserModules(userModules)
    baseVuexStore.setUserModules(userModules)
    baseVuetify.setUserModules(userModules)
  })
  await authStore.registerUserModuleHook((userModule) => {
    baseVueRouter.setUserModule(userModule)
    baseVuexStore.setUserModule(userModule)
    baseVuetify.setUserModule(userModule)
    baseAxios.setUserModule(userModule)
  })
  await authStore.registerLoginHook(async () => {
    baseVueRouter.setEnabledRouteNotFound(true)
    await baseFirebase.setEnabledNotification(true)
  })
  await authStore.registerLogoutHook(async () => {
    await appStore.clearNotifications()
    baseAxios.cancelRequests()
    await baseFirebase.setEnabledNotification(false)
    baseVueRouter.setEnabledRouteNotFound(false)
    clearLocalStorage(MAIN_DEAFULT_STORAGE_KEYS)
  })

  baseServiceWorker.start()
  await appStore.start()
  await authStore.start()

  Vue.config.productionTip = false

  new Vue({
    router: baseVueRouter,
    i18n: baseVueI18n,
    store: baseVuexStore,
    vuetify: baseVuetify,
    render: (html) => html(BaseIndexVue)
  }).$mount('#index')
}

main()